import { applyCurrencyFormat } from "@puregym/utilities/currencyFormat";
import labels from "../components/labels";

export const formatSalesTax = (price: number, salesTax?: number) =>
  salesTax
    ? `${applyCurrencyFormat(price)} ${labels.joinMonthlyPackages.salesTax}`
    : `${applyCurrencyFormat(price)}`;
